import * as React from 'react';
import { Link } from 'react-router-dom';
import { MenuItem } from '../pages/interfaces/PageInterfaces';
import { matchPath } from 'react-router';


export const MijnFNVMenu = (menuItems: MenuItem[], currentLocationPath) => {
  return <ul className="mijn-fnv__menu-sidebar">
    {menuItems.map((item , index) => {
        const matchedPath = matchPath(
          currentLocationPath, 
          item.Url
        ); 
        const isMenuActive : boolean = matchedPath !== null ? matchedPath.isExact : false;
    
        return (<li key={"MenuItem" +  index} 
          className={isMenuActive ? 'active' : ''}>{isMenuActive ? getMenuAsTextItem(item) : getLinkItem(item)}</li>);
      }
    )}
  </ul>;
};



// Determine what css class we give to li
const isActive = (item: MenuItem) => (item.IsCurrent ? 'active' : '');

// Determine how we present the link
const getLinkItem = (item: MenuItem) => {
  
  if (!item.IsClickable) {
    // not a link
    return <span className="link-">{item.Title}</span>;
  } else {
    return <Link to={item.Url}><span>{item.Title}</span></Link>;
  }
};

const getMenuAsTextItem = (item: MenuItem) => {  
  return <span className="mijn-fnv__menu-as-text">{item.Title}</span>;
};